module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-Regular.9ec59438.woff2";